import 'firebase/compat/firestore';
import firebase from 'firebase/compat/app';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";





const config = {
  apiKey: "AIzaSyChxnAHKqTHk2KEXyocqzIUHdiEI-vwQKM",
  authDomain: "venturecapital-portal.firebaseapp.com",
  projectId: "venturecapital-portal",
  storageBucket: "venturecapital-portal.appspot.com",
  messagingSenderId: "927055419953",
  appId: "1:927055419953:web:4a37c8f5475c0affad1310",
  measurementId: "G-VER1RGCGE5"
};

const app = firebase.initializeApp(config)
const db = app.firestore().collection("Formulieren");

const auth = getAuth();



export { db, auth, signInWithEmailAndPassword }
